function AboutMe() {
    return (
        <div>
            <h1>
                I am 21 years old. I was born in Richmond, VA and now go to the University of Virginia. I enjoy fishing, watching sports, and hanging out with friends.
            </h1>
        </div>
    );
    }
    export default AboutMe;